import {
  CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE,
  DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST,
  UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE,
  DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS,
  UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS,
} from "./ActionType";

const initialState = {
  designerDiscountBanners: [],
  designerDiscountBanner: null,
  loading: false,
  error: "",
};

export const adminDesignerDiscountBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DESIGNER_DISCOUNT_BANNER_REQUEST:
      return { ...state, loading: true };

    case CREATE_DESIGNER_DISCOUNT_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", designerDiscountBanner: action.payload };

    case CREATE_DESIGNER_DISCOUNT_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_DESIGNER_DISCOUNT_BANNER_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_DESIGNER_DISCOUNT_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", designerDiscountBanners: action.payload };

    case GET_ALL_DESIGNER_DISCOUNT_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_DESIGNER_DISCOUNT_BANNER_REQUEST:
      return { ...state, loading: true };

    case DELETE_DESIGNER_DISCOUNT_BANNER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        designerDiscountBanners: state.designerDiscountBanners?.response?.filter(bnr => bnr.id !== action.payload)  // Remove deleted category
      };

    case DELETE_DESIGNER_DISCOUNT_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_DESIGNER_DISCOUNT_BANNER_REQUEST:
      return { ...state, loading: true };

    case UPDATE_DESIGNER_DISCOUNT_BANNER_SUCCESS:
      return { ...state, loading: false, error: "", designerDiscountBanner: action.payload };

    case UPDATE_DESIGNER_DISCOUNT_BANNER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
